// extracted by mini-css-extract-plugin
export var link = "LegalNav-module--link--FMezw";
export var active = "LegalNav-module--active--2hxwb";